import React, { useState, useEffect, useRef } from 'react';
import '../App.css';


import closeIcon from '../assets/icons.png';
import userAvatar from '../assets/user.png';
import botAvatar from '../assets/bot.png';
import sendIcon from '../assets/send.png';
import scrollIcon from '../assets/arrow.png';
//import micIcon from '../assets/mic.png';
//import startSound from '../assets/start.mp3'; 
import footerImage from '../assets/footer.png'; 
//import endSound from '../assets/end.mp3';

function ChatbotPage() {
  const [messages, setMessages] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [isTyping, setIsTyping] = useState(false);
  const [showScrollButton, setShowScrollButton] = useState(false);
  const [stopTyping, setStopTyping] = useState(false);
  const [isResponseActive, setIsResponseActive] = useState(false);
  const [isIntroComplete, setIsIntroComplete] = useState(false);
  const messagesEndRef = useRef(null);
  const scrollRef = useRef(null);
  const typingIntervalRef = useRef(null); 
  const [isUserScrolling, setIsUserScrolling] = useState(false);
  const userScrollingTimeoutRef = useRef(null);
  const [isAutoScrollAllowed, setIsAutoScrollAllowed] = useState(true); 
  const clientId = 4;
 
  const closeChat = () => {
    window.parent.postMessage("closeChatbot", "*");
  };

 


 const handleSubmit = async (userMessageText) => {
    if (loading || isResponseActive) return;

    // Stop any ongoing intro message if the user sends a message
    if (!isIntroComplete) {
      clearInterval(typingIntervalRef.current);
      setStopTyping(true);
    }

    const userMessage = {
        text: userMessageText || inputValue,
        sender: 'user',
    };

    setMessages((prevMessages) => [...prevMessages, userMessage]);
    setInputValue("");
// ✅ Scroll to bottom immediately after user submits a message
setTimeout(() => {
  messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
}, 100);
    setLoading(true);
    setIsResponseActive(true);

    try {
        const response = await fetch('/api/get', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json',
              'Cache-Control': 'no-cache,no-store,must-revalidate' },
            body: JSON.stringify({ message: userMessage.text,client_id: clientId }),
            
        });

        if (response.ok) {
            const data = await response.json();
           // console.log("Raw API Response:", data.response);

            const botMessage = {
                text: "",
                sender: 'bot',
                suggestions: (data.suggestions || []).slice(0, 2).map((suggestion) =>
                  suggestion.replace(/^\d+[\).\s]/, "") // Removes "1. ", "2) ", etc.
                ),
              };
        

            setMessages((prevMessages) => [...prevMessages, botMessage]);

            typeMessage(formatResponse(data.response), () => {
                setLoading(false);
                setIsResponseActive(false);
            });
        } else {
            console.error("Server error:", response.statusText);
            setLoading(false);
            setIsResponseActive(false);
        }
    } catch (error) {
        console.error("Error:", error);
        setLoading(false);
        setIsResponseActive(false);
    }
};

const formatResponse = (response) => {
  // Fix double "hhttps" issue
  response = response.replace(/\bhhttps:\/\//g, 'https://').replace(/\bhere\b|[\[\]]/gi, '');

  // Replace URLs with a placeholder for typeMessage() to detect
  const urlPattern = /\b(https?|ftp|file):\/\/\S+/ig;
  response = response.replace(urlPattern, (url) => {
    return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
  });

  return response
    .replace(/\*\*/g, '')
    .replace(/\n\*/g, '<br>&bull; ')
    .replace(/\n\-/g, '<br>&bull; ')
    .replace(/\n\d+\./g, (match) => '<br>' + match.trim());
};


const typeMessage = (message, callback) => {
  let index = 0;
  setIsTyping(true);
  setStopTyping(false);

  const linkPattern = /\s+href="[^"]+"\s+target="_blank"\s+rel="noopener noreferrer">[^<]+<\/a>/g;
  let matches = [...message.matchAll(linkPattern)];
  let currentLink = matches.shift();

  typingIntervalRef.current = setInterval(() => {
    if (index < message.length) {
      if (stopTyping) {
        clearInterval(typingIntervalRef.current);
        setIsTyping(false);
        setStopTyping(false);
        return callback && callback();
      }

      setMessages((prevMessages) => {
        const newMessage = {
          ...prevMessages[prevMessages.length - 1],
          text: prevMessages[prevMessages.length - 1].text + message[index],
        };
        return [...prevMessages.slice(0, -1), newMessage];
      });

      if (currentLink && index === currentLink.index) {
        const linkText = currentLink[0];
        setMessages((prevMessages) => {
          const newMessage = {
            ...prevMessages[prevMessages.length - 1],
            text: prevMessages[prevMessages.length - 1].text + linkText,
          };
          return [...prevMessages.slice(0, -1), newMessage];
        });
        index += linkText.length;
        currentLink = matches.shift();
      } else {
        index++;
      }

      if (isAtBottom(scrollRef) && isAutoScrollAllowed) {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      clearInterval(typingIntervalRef.current);
      setIsTyping(false);
      if (callback) callback();
    }
  }, 40);
};


  useEffect(() => {
    const fetchWelcomeMessage = async () => {
      try {
        const response = await fetch('/api/get_intro?client_id=4');
        if (response.ok) {
          const data = await response.json();
          const welcomeMessage = { text: "", sender: 'bot' };
          setMessages((prevMessages) => [...prevMessages, welcomeMessage]);
          typeMessage(data.message, () => {
            setIsTyping(false);
            setIsIntroComplete(true);
          });
        } else {
          console.error("Failed to fetch welcome message:", response.statusText);
        }
      } catch (error) {
        console.error("Error fetching welcome message:", error);
      }
    };
    fetchWelcomeMessage();
  }, []);

  useEffect(() => {
    if (isIntroComplete) return;
    const { scrollTop, scrollHeight, clientHeight } = scrollRef.current;
    const isUserAtBottom = scrollHeight - scrollTop === clientHeight;

    if (isUserAtBottom || isTyping) {
      messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [isTyping, isIntroComplete]); 


  useEffect(() => {
    const handleScroll = () => {
      if (!scrollRef.current) return;
  
      const { scrollTop, scrollHeight, clientHeight } = scrollRef.current;
      const isNearBottom = scrollHeight - scrollTop - clientHeight < 50;
  
      if (!isNearBottom) {
        // User manually scrolled, disable auto-scroll
        setIsUserScrolling(true);
        setIsAutoScrollAllowed(false);
  
        // Reset manual scrolling flag after 2 seconds of no activity
        clearTimeout(userScrollingTimeoutRef.current);
        userScrollingTimeoutRef.current = setTimeout(() => {
          setIsUserScrolling(false);
        }, 2000);
      } else {
        // User scrolled back to bottom, enable auto-scroll
        setIsUserScrolling(false);
        setIsAutoScrollAllowed(true);
      }
  
      // Show the "scroll-to-bottom" button if not near bottom
      setShowScrollButton(!isNearBottom);
    };
  
    const ref = scrollRef.current;
    ref.addEventListener("scroll", handleScroll);
  
    return () => {
      ref.removeEventListener("scroll", handleScroll);
      clearTimeout(userScrollingTimeoutRef.current);
    };
  }, []);
  
 
  const isAtBottom = (ref) => {
    if (!ref.current) return false;
    const { scrollTop, scrollHeight, clientHeight } = ref.current;
    return scrollHeight - scrollTop - clientHeight < 50; // Adjust threshold if needed
  };
  
  
  const handleSuggestionClick = (suggestion) => {
    handleSubmit(suggestion); // Submit the suggestion as a user message
  };


  
  
  const micButtonStyle = isResponseActive ? { filter: 'grayscale(100%)' } : {};
  const sendButtonStyle = loading || isResponseActive ? { filter: 'grayscale(100%)' } : {};

  
  
  return (
    <div className="chat-container">
      <div className="card">
        <div className="card-header msg_head">
          <div className="d-flex bd-highlight">
            <div className="img_cont">
    
            </div>
            <div className="ml-auto">
              <button type="button" className="close" aria-label="Close" id="closeChat" onClick={closeChat}>
                <img src={closeIcon} alt="Close"  loading="lazy"/>
              </button>
            </div>
          </div>
        </div>
        <div id="messageFormeight" className="card-body msg_card_body" ref={scrollRef}>
        {messages.map((msg, index) => (
            <div key={index}>
              {/* User or Bot Messages */}
              <div className={`d-flex justify-content-${msg.sender === 'user' ? 'end' : 'start'} mb-4`}>
                {msg.sender === 'bot' && (
                  <div className="img_cont_msg">
                    <img src={botAvatar} className="rounded-circle user_img_msg" alt="Bot"  loading="lazy"/>
                  </div>
                )}
                <div className={`msg_cotainer${msg.sender === 'user' ? '_send' : ''}`}>
                  <div dangerouslySetInnerHTML={{ __html: msg.text }} />
                </div>
                {msg.sender === 'user' && (
                  <div className="img_cont_msg">
                    <img src={userAvatar} className="rounded-circle user_img_msg" alt="User"  loading="lazy"/>
                  </div>
                )}
              </div>

              {/* Suggestions After Bot Response Completion */}
              {msg.sender === 'bot' && !isTyping && msg.suggestions?.length > 0 && (
                <div className="suggestion-container">
                  {msg.suggestions.map((suggestion, idx) => (
                    <button
                      key={idx}
                      className="suggestion-button"
                      onClick={() => handleSuggestionClick(suggestion)}
                    >
                      {suggestion}
                    </button>
                  ))}
                </div>
              )}
            </div>
          ))}

          {loading && !isTyping && (
            <div className="d-flex justify-content-start mb-4">
              <div className="img_cont_msg">
                <img src={botAvatar} className="rounded-circle user_img_msg" alt="Bot"  loading="lazy"/>
              </div>
              <div className="msg_cotainer">
                <div className="loading-indicator"></div>
              </div>
            </div>
          )}
          <div ref={messagesEndRef} />
        </div>
        <div className="card-footer">
  <form id="messageArea" className="input-group" onSubmit={(e) => { e.preventDefault(); handleSubmit(inputValue); }}>
   {/* <button type="button" id="mic" className="mic-button" onClick={toggleSpeechRecognition} style={micButtonStyle}>
      <div className="mic-shadow"></div>
     <img src={micIcon} alt="Microphone" loading="lazy" style={{ width: '40px', height: '40px' }} />
    </button> */}
    <input
      type="text"
      id="text"
      name="msg"
      value={inputValue}
      onChange={(e) => setInputValue(e.target.value)}
      className="form-control type_msg"
      placeholder="Ask me anything..."
    />
    <button type="submit" className="input-group-text send_btn">
      <img src={sendIcon} alt="Send" loading="lazy"
        onClick={() => handleSubmit(inputValue)} style={sendButtonStyle} disabled={loading || isResponseActive}
      />
    </button>
  </form>
  {showScrollButton && (
  <button
    onClick={() => {
      scrollRef.current.scrollTo({
        top: scrollRef.current.scrollHeight,
        behavior: "smooth",
      });
      setIsAutoScrollAllowed(true); // Explicitly re-enable auto-scroll
    }}
    className="scroll-to-bottom"
  >
    <img src={scrollIcon} alt="Scroll Down"  loading="lazy"/>
  </button>
)}

              
              <div className="text-center footer">
                <a href="https://www.papermoon.in" target="_blank" rel="noopener noreferrer">
                  <img src={footerImage} alt="Footer" className="footer-img" loading="lazy" />
                </a>
              </div>
            </div>
          </div>
        </div>
      );
    }
    


    export default ChatbotPage;
